'use strict';

import './BackgroundGraphic.less';

import React from 'react';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class BackgroundGraphic extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { name, top, left, right, bottom, styles } = this.props;

		const allStyles = Object.assign(
			{
				top: top,
				left: left,
				right: right,
				bottom: bottom
			},
			styles
		);

		return (
			<div className={'BackgroundGraphic'} style={allStyles}>
				<ReactCKImage name={name} />
			</div>
		);
	}
}

BackgroundGraphic.propTypes = {
	name: PropTypes.string.isRequired,
	top: PropTypes.string,
	left: PropTypes.string,
	right: PropTypes.string,
	bottom: PropTypes.string,
	styles: PropTypes.object
};
